import styled from 'styled-components';
import { Card } from 'antd';
import { COLORS } from '../../theme';

export const Wrapper = styled.div`
  background-color: ${COLORS.black};
  height: 100%;
  position: absolute;
  width: 100%;
  background-image: linear-gradient(
    180deg,
    ${COLORS.black},
    ${COLORS.primary} 500%,
    ${COLORS.primary}
  );

  .ant-btn {
    width: 100%;
  }
`;

export const FormWrapper = styled(Card)`
  max-width: 350px;
  margin: 200px auto auto;
  border-radius: 10px;
  background-color: ${COLORS.lightDark};
`;

export const FromTitle = styled.div`
  margin-bottom: 70px;
  font-size: 1.7em;
  font-weight: 700;
  text-align: center;
  color: ${COLORS.secondary};
`;
export const Logo = styled.img`
  width: 200px;
  margin-left: auto;
  margin-top: 26px;
  margin-right: auto;
  display: block;
`;

export const Footer = styled.div`
  color: #ffffff;
  font-size: 0.8em;
  text-align: center;
  margin-top: 24px;
`;
